module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<fieldset <%- formMapping.additionalClass ? 'class=\"' + formMapping.additionalClass + '\"' : '' %>>\n<% utils.forEach(formMapping.fields, function(field){ %>\n<%- include(field.type, { formMapping: field, model, config }); %>\n<% }); %>\n</fieldset>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\elements\\fieldset.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<fieldset ")
    ; __append( formMapping.additionalClass ? 'class="' + formMapping.additionalClass + '"' : '' )
    ; __append(">\n")
    ; __line = 2
    ;  utils.forEach(formMapping.fields, function(field){ 
    ; __append("\n")
    ; __line = 3
    ; __append( include(field.type, { formMapping: field, model, config }) )
    ; __append("\n")
    ; __line = 4
    ;  }); 
    ; __append("\n</fieldset>")
    ; __line = 5
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\elements\fieldset.ejs

}